var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Roboto;font-style:normal;font-weight:400;src:url(" + escape(require("./roboto/Roboto-Regular.ttf")) + ") format(\"truetype\")}@font-face{font-family:Roboto;font-style:normal;font-weight:300;src:url(" + escape(require("./roboto/Roboto-Light.ttf")) + ") format(\"truetype\")}@font-face{font-family:Roboto;font-style:normal;font-weight:500;src:url(" + escape(require("./roboto/Roboto-Medium.ttf")) + ") format(\"truetype\")}@font-face{font-family:Roboto;font-style:normal;font-weight:700;src:url(" + escape(require("./roboto/Roboto-Bold.ttf")) + ") format(\"truetype\")}", ""]);

// exports
